module.exports = __webpack_public_path__ + "img/default_avatar.8f3a5c06.svg";